const BannerList = () => import('@/vuepage/views-manage/BannerList');
const AboutUs = () => import('@/vuepage/views-manage/AboutUs');
const CoreTechnology = () => import('@/vuepage/views-manage/CoreTechnology');
const CoreTechnologyDialog = () => import('@/vuepage/views-manage/components/CoreTechnologyDialog');
const ServiceList = () => import('@/vuepage/views-manage/ServiceList');
const QuestionList = () => import('@/vuepage/views-manage/QuestionList');
const Bcxy = () => import('@/vuepage/views-manage/bcxy');
const Ysxy = () => import('@/vuepage/views-manage/ysxy');
const Yhxy = () => import('@/vuepage/views-manage/yhxy');

export default [{
		path: '/banner-list',
		component: BannerList,
		meta: [{
				name: '展示管理'
			},
			{
				name: 'Banner管理',
				activeRoute: '/banner-list'
			}
		]
	},
	{
		path: '/about-us',
		component: AboutUs,
		meta: [{
				name: '展示管理'
			},
			{
				name: '关于我们',
				activeRoute: '/about-us'
			}
		]
	},
	{
		path: '/core-technology',
		component: CoreTechnology,
		meta: [{
				name: '展示管理'
			},
			{
				name: '核心技术',
				activeRoute: '/core-technology'
			}
		]
	},
	{
		path: '/core-technology-dialog',
		component: CoreTechnologyDialog,
		meta: [{
				name: '展示管理'
			},
			{
				name: '核心技术',
				activeRoute: '/core-technology'
			},
			{
				name: '新增/编辑核心技术',
				activeRoute: '/core-technology-dialog'
			}
		]
	},
	{
		path: '/service-list',
		component: ServiceList,
		meta: [{
				name: '展示管理'
			},
			{
				name: '服务据点管理',
				activeRoute: '/service-list'
			}
		]
	},
	{
		path: '/question-list',
		component: QuestionList,
		meta: [{
				name: '展示管理'
			},
			{
				name: '常见问题',
				activeRoute: '/question-list'
			}
		]
	},
	{
		path: '/bcxy',
		component: Bcxy,
		meta: [{
				name: '协议管理'
			},
			{
				name: '补充协议',
				activeRoute: '/bcxy'
			}
		]
	},
	{
		path: '/yhxy',
		component: Yhxy,
		meta: [{
				name: '协议管理'
			},
			{
				name: '用户协议',
				activeRoute: '/yhxy'
			}
		]
	},
	{
		path: '/ysxy',
		component: Ysxy,
		meta: [{
				name: '协议管理'
			},
			{
				name: '隐私协议',
				activeRoute: '/ysxy'
			}
		]
	},

];